import script from "./userLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./userLayout.vue?vue&type=script&setup=true&lang=js"

import "./userLayout.vue?vue&type=style&index=0&id=642e0b9c&lang=css"

const __exports__ = script;

export default __exports__